import { render, staticRenderFns } from "./xpsexpressorderDeliveryOne.vue?vue&type=template&id=e0b961b4"
import script from "./xpsexpressorderDeliveryOne.vue?vue&type=script&lang=js"
export * from "./xpsexpressorderDeliveryOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports